import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import ProductFilter from '../../common/menu/products-filter';
import Categories from './categories';

const { Order, UI } = Mobi2Go;

class MenuProducts extends React.Component {
    static propTypes = {
        root: PropTypes.instanceOf(Element).isRequired,
    };

    constructor(...args) {
        super(...args);

        this.state = {
            categories: new Mobi2Go._class.Common.Collection([]),
            selected_category_id: null,
        };

        this.ui_event_listeners = {
            showCategory: this.showCategory,
            scrollToCategory: this.scrollToCategory,
            scrollToProduct: this.scrollToProduct,
        };

        this.order_event_listeners = {
            updateMenu: this.updateState,
            updateMenuRestrictions: this.updateState,
            updateExpectedAt: this.updateState,
            updateMenuTierId: this.updateState,
            updateMenuLevelId: this.updateState,
        };

        this.is_scrolling = false;
    }

    componentWillUnmount() {
        UI.unbind(this.ui_event_listeners);

        Order.unbind(this.order_event_listeners);

        window.removeEventListener('resize', this.onWindowResize);
        window.removeEventListener('scroll', this.onWindowScroll);
    }

    componentDidMount() {
        UI.bind(this.ui_event_listeners);

        Order.bind(this.order_event_listeners);

        this.updateState();
        this.equaliseProductElementHeights();
        this.triggerMenuProductsViewRenderedEvent();
        this.removeLoader();

        window.addEventListener('resize', this.onWindowResize);
        window.addEventListener('scroll', this.onWindowScroll);
    }

    componentDidUpdate() {
        this.showCategory(this.state.selected_category_id);
        this.equaliseProductElementHeights();
        this.triggerMenuProductsViewRenderedEvent();
    }

    onWindowResize = _.debounce(() => {
        this.doEqualisationOfProductElementHeights();
    }, 300);

    onWindowScroll = () => {
        this.is_scrolling = true;
        clearTimeout(this.is_scrolling_timeout);
        this.is_scrolling_timeout = setTimeout(() => {
            this.is_scrolling = false;
        }, 500);
    };

    removeLoader() {
        const element = document.querySelector(
            '.m2g-view .m2g-menu [data-menu-loader]'
        );
        if (element) {
            element.parentNode.removeChild(element);
        }
    }

    triggerMenuProductsViewRenderedEvent() {
        UI.trigger('menuProductsViewRendered');
    }

    updateState = () => {
        const categories = Order.getMenu().getCategories();
        categories.set(
            categories.filter(category => {
                const products = ProductFilter(
                    category.getProducts().toArray()
                );
                return products.length > 0;
            })
        );
        let { selected_category_id } = this.state;

        if (
            categories.getLength() > 0 &&
            (!selected_category_id ||
                !categories.find({ id: selected_category_id }))
        ) {
            selected_category_id = categories.first().id;
        }
        this.setState({
            categories,
            selected_category_id,
        });
    };

    showCategory = id => {
        let category;
        if (!_.isNumber(id)) {
            const name = id;
            category = Order.getMenu()
                .getCategories()
                .getByName(name);
        } else {
            category = Order.getMenu()
                .getCategories()
                .find({ id });
        }

        if (!category) {
            return;
        }

        if (this.state.selected_category_id === category.id) {
            this.props.root.setAttribute('data-showing-category', category.id);
            this.props.root.setAttribute(
                'data-showing-category-name',
                category.backend_name
            );
        } else {
            this.setState({
                selected_category_id: category.id,
            });
        }
        this.equaliseProductElementHeights();
    };

    scrollToCategory = (id, force_scroll, offset) => {
        let category;
        if (!_.isNumber(id)) {
            category = Order.getMenu()
                .getCategories()
                .getByName(id);
        } else {
            category = Order.getMenu()
                .getCategories()
                .find({ id });
        }

        if (!category) {
            return;
        }

        offset = parseInt(offset) || 0;

        UI.helpers.scrollTo(
            `[data-view="menu-products"] [data-category="${category.id}"]`,
            null,
            !!force_scroll,
            -100 + offset
        );
    };

    scrollToProduct = (id, force_scroll) => {
        let product;
        if (!_.isNumber(id)) {
            product = Order.getMenu().getProductByName(id);
        } else {
            product = Order.getMenu().getProductById(id);
        }

        if (!product) {
            return;
        }

        console.log(
            `[data-view="menu-products"] [data-product="${product.id}"]`
        );

        UI.helpers.scrollTo(
            `[data-view="menu-products"] [data-product="${product.id}"]`,
            null,
            !!force_scroll,
            -100
        );
    };

    /**
     * Product list can be of varying length due to image size, product
     * name and description length. A good looking list cannot be achieved
     * with pure CSS. This code below loops through each category of products
     * and makes each product in the category the height of the tallest
     * product in the category.
     */
    equaliseProductElementHeights = () => {
        this.doEqualisationOfProductElementHeights();
        this.timeouts = this.timeouts || [];

        _.each(this.timesouts, clearTimeout);
        this.timeouts[0] = setTimeout(
            this.doEqualisationOfProductElementHeights,
            500
        );
        this.timeouts[1] = setTimeout(
            this.doEqualisationOfProductElementHeights,
            1000
        );
        this.timeouts[2] = setTimeout(
            this.doEqualisationOfProductElementHeights,
            3500
        );
        this.timeouts[3] = setTimeout(
            this.doEqualisationOfProductElementHeights,
            5500
        );
        this.timeouts[4] = setTimeout(
            this.doEqualisationOfProductElementHeights,
            7500
        );
        this.timeouts[5] = setTimeout(
            this.doEqualisationOfProductElementHeights,
            10000
        );
        this.timeouts[6] = setTimeout(
            this.doEqualisationOfProductElementHeights,
            14000
        );
    };

    doEqualisationOfProductElementHeights = () => {
        if (!this.shouldEqualiseProductElementHeights() || this.is_scrolling) {
            return;
        }

        if (!this.categories_root) {
            return;
        }

        const category_nodes = this.categories_root.getCategoryNodes();
        _.each(Object.keys(category_nodes), category_id => {
            const category_node = category_nodes[category_id];
            if (!category_node) {
                return;
            }

            const product_nodes = category_node.getProductNodes();
            let maximum_height = 0;

            _.each(Object.keys(product_nodes), product_id => {
                const product_node = product_nodes[product_id];
                if (!product_node) {
                    return;
                }

                const dom_node = product_node.getDOMNode();
                if (!dom_node) {
                    return;
                }
                const previous_min_height = dom_node.style.minHeight;
                dom_node.style.minHeight = 'auto';
                const node_height = dom_node.offsetHeight;
                dom_node.style.minHeight = previous_min_height;
                maximum_height =
                    node_height > maximum_height ? node_height : maximum_height;
            });

            maximum_height = maximum_height < 130 ? 130 : maximum_height;

            category_node.setProductMinHeight(maximum_height);
        });
    };

    shouldEqualiseProductElementHeights = () => {
        return (
            this.product_equalise_size_node &&
            // jQuery.is(':visible')
            (this.product_equalise_size_node.offsetWidth > 0 ||
                this.product_equalise_size_node.offsetHeight > 0)
        );
    };

    render() {
        const { categories, selected_category_id } = this.state;

        return [
            <div
                key="product-equalise-size"
                data-product-equalise-size
                className="m2g-hidden"
                ref={e => (this.product_equalise_size_node = e)}
            />,
            <Categories
                key="categories"
                data={categories.toArray()}
                selected_category_id={selected_category_id}
                ref={e => (this.categories_root = e)}
            />,
            <div key="clearfix" className="m2g-clearfix" />,
        ];
    }
}

export default MenuProducts;
